import { Button, Checkbox, FormControlLabel, SelectChangeEvent, Stack } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { equivalentThickness, physicalData, relativeDensity, rockD50, shieldsParameter, thickness } from '../../conversion/physicalData';
import InputText from '../../shared/component/InputText';
import { EUnitOfMeasure } from '../../shared/enum';
import { IPhysicalData } from '../../shared/iProject';
import { useAppDispatch, useAppSelector } from '../../store/hook';
import { removeMaterialDoubleLayer, selectProject, setGeometry, setMaterial, setPhysicalData } from '../../store/project/projectSlice';
import { Context } from './Index';
import Swal from 'sweetalert2';
import { cleanResult } from '../../store/result/resultSlice';
import { cleanEngine } from '../../store/engine/engineSlice';
import { cleanMap } from '../../store/map/mapSlice';
import { cleanAlert } from '../../store/alert/alertSlice';

interface IRipRapProps {}

const RipRap = (props: IRipRapProps) => {
    const context = React.useContext(Context);

    const project = useAppSelector(selectProject);

    const [physicalDataState, setPhysicalDataState] = React.useState<IPhysicalData>(
        project.data?.material?.baseMaterialId == context!.baseMaterial!.id ? project!.data!.material!.physicalData[0] : context!.baseMaterial!.physicalData[0],
    );

    const dispatch = useAppDispatch();

    const { t } = useTranslation();

    const handleChangeEquivalentThickness = (event: React.ChangeEvent<any> | SelectChangeEvent<any>) => {
        let { value } = event.target;

        let equivalentThickness = value;
        let rockD50 = Math.round((equivalentThickness / 0.84) * 100) / 100;
        let thickness = Math.round(rockD50 * 1.5 * 100) / 100;

        if (project.data?.project?.unitOfMeasure == EUnitOfMeasure.Metric) {
            setPhysicalDataState({ ...physicalDataState, equivalentThickness, thickness, rockD50 });
        } else {
            setPhysicalDataState({ ...physicalDataState, equivalentThicknessIn: equivalentThickness, thicknessIn: thickness, rockD50in: rockD50 });
        }
    };

    const handleChange = (event: React.ChangeEvent<any> | SelectChangeEvent<any>) => {
        let { name, value } = event.target;
        setPhysicalDataState({ ...physicalDataState, [name]: value });
    };

    const handleClickApply = () => {
        dispatch(cleanResult());
        dispatch(cleanEngine());
        dispatch(cleanMap());
        dispatch(cleanAlert());
        dispatch(removeMaterialDoubleLayer());
        dispatch(setGeometry({ ...project.data!.geometry!, doubleLayerNearToTheQuayWall: false }));
        dispatch(setMaterial({ ...context!.baseMaterial, physicalData: [{...physicalDataState, widthOfTheProtectionW: project.data?.material?.physicalData[0].widthOfTheProtectionW!}], id: project.data!.material!.id!, baseMaterialId: context!.baseMaterial!.id!, isBaseMaterial: false }));
        Swal.fire({
            title: t('addedMaterial'),
            icon: 'success',
            toast: true,
            position: 'top',
            showConfirmButton: false,
            timer: 2000,
        });
    };

    return (
        <Stack direction={'column'} spacing={1}>
            <FormControlLabel control={<Checkbox checked={context!.baseMaterial.geotextileFilter} disabled />} label={t('geotextileFilter')} />
            <InputText
                className='btn'
                id={equivalentThickness}
                customValue={project.data?.project?.unitOfMeasure == EUnitOfMeasure.Metric ? physicalDataState.equivalentThickness : physicalDataState.equivalentThicknessIn}
                isNumber
                inputLabel={t(equivalentThickness, {
                    unitOfMeasure: physicalData['equivalentThickness'].unitOfMeasure[project.data!.project!.unitOfMeasure!],
                })}
                name={equivalentThickness}
                customOnChange={handleChangeEquivalentThickness}
            />
            <Stack direction={'row'}>
                <InputText
                    disabled
                    id={thickness}
                    customValue={project.data?.project?.unitOfMeasure == EUnitOfMeasure.Metric ? physicalDataState.thickness : physicalDataState.thicknessIn}
                    isNumber
                    inputLabel={t(thickness, {
                        unitOfMeasure: physicalData['thickness'].unitOfMeasure[project.data!.project!.unitOfMeasure!],
                    })}
                    name={thickness}
                />
                <InputText
                    disabled
                    id={rockD50}
                    customValue={project.data?.project?.unitOfMeasure == EUnitOfMeasure.Metric ? physicalDataState.rockD50 : physicalDataState.rockD50in}
                    isNumber
                    inputLabel={t(rockD50, {
                        unitOfMeasure: physicalData['thickness'].unitOfMeasure[project.data!.project!.unitOfMeasure!],
                    })}
                    name={rockD50}
                />
                <InputText
                    className='btn'
                    id={relativeDensity}
                    customValue={physicalDataState.relativeDensity}
                    isNumber
                    inputLabel={t(relativeDensity)}
                    name={relativeDensity}
                    customOnChange={handleChange}
                />
            </Stack>
            <InputText disabled id={shieldsParameter} customValue={physicalDataState.shieldsParameter} isNumber inputLabel={t(shieldsParameter)} name={shieldsParameter} />
            <Stack direction={'row'} spacing={5} justifyContent={'flex-end'}>
                <Button className='btn' variant='white' onClick={() => context!.handleClose()}>
                    {t('close')}
                </Button>
                <Button className='btn' variant='orange' onClick={handleClickApply}>
                    {t('apply')}
                </Button>
            </Stack>
        </Stack>
    );
};

export default RipRap;
